module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAADBAMAAAAXToCWAAAAAXNSR0IB2cksfwAAABhQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVjccKgAAAAh0Uk5TAFB/b8D/MICPD4umAAAAGElEQVR4nGMQUsIEygyuoVgAQ3o5JigEAONIE1ISRLL6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/minus@2x.png
// module id = 871
// module chunks = 0